import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend/cjs";
import installationPage from "./default/installationPage.json";
import dashboardPage from "./default/dashboardPage.json";
import deviceList from "./default/deviceList.json";
import installationDetailTile from "./default/installationDetailTile.json";
import devicePage from "./default/devicePage.json";
import deviceDetailTile from "./default/deviceDetailTile.json";
import createDeviceButton from "./default/createDeviceButton.json";
import switchLanguageModal from "./default/switchLanguageModal.json";
import profileMenu from "./default/profileMenu.json";
import page403 from "./default/403Page.json";
import page404 from "./default/404Page.json";
import errorBoundary from "./default/errorBoundary.json";
import sideNavigation from "./default/sideNavigation.json";
import insights from "./default/insights.json";
import storePage from "./default/storePage.json";
import toasts from "./default/toasts.json";
import accountPage from "./default/accountPage.json";
import noAccountsPage from "./default/noAccountsPage.json";
import tabsPage from "./default/tabs.json";

const translationDefault = {
  ...installationPage,
  ...dashboardPage,
  ...deviceList,
  ...installationDetailTile,
  ...devicePage,
  ...deviceDetailTile,
  ...switchLanguageModal,
  ...createDeviceButton,
  ...profileMenu,
  ...page403,
  ...page404,
  ...sideNavigation,
  ...errorBoundary,
  ...insights,
  ...storePage,
  ...toasts,
  ...accountPage,
  ...noAccountsPage,
  ...tabsPage,
};

i18n
  .use(initReactI18next)
  .use(HttpApi)
  .init({
    // debug: true,
    fallbackLng: "default",
    defaultNS: "translation",
    load: "currentOnly",
    interpolation: {
      escapeValue: false,
    },
    partialBundledLanguages: true,
    ns: [],
    resources: {},
    backend: {
      loadPath: `https://cdn.grundfos.com/core-devicemanager/localization/{{lng}}.json`,
    },
  });

i18n.addResourceBundle("default", "translation", translationDefault);

export default i18n;
